import React from "react";
import Marquee from "react-fast-marquee";

import "../../../assets/scss/components/sections/home/company-logos.scss";

import logo1 from "../../../assets/images/home/company-1.svg";
import logo2 from "../../../assets/images/home/company-2.svg";
import logo3 from "../../../assets/images/home/company-3.svg";
import logo4 from "../../../assets/images/home/company-4.svg";
import logo5 from "../../../assets/images/home/company-5.svg";
import logo6 from "../../../assets/images/home/company-6.svg";
import logo8 from "../../../assets/images/home/company-8.svg";
import logo7 from "../../../assets/images/home/company-7.svg";
import logo9 from "../../../assets/images/home/company-9.svg";
import logo10 from "../../../assets/images/home/company-10.svg";

const CompanyLogos = () => {
  const companyLogosIcons = [
    logo1,
    logo2,
    logo3,
    logo4,
    logo5,
    logo6,
    logo7,
    logo8,
    logo9,
    logo10,
  ];

  return (
    <div className="company-logos-section">
      <h3 className="company-logos-section-heading">
        Trusted by job seekers at top companies
      </h3>
      <Marquee speed={50} gradient={false}>
        {companyLogosIcons.map((logo, index) => (
          <img
            key={`logo-${index}`}
            src={logo}
            alt={`Logo ${index + 1}`}
            className="marquee-logo"
          />
        ))}
      </Marquee>
    </div>
  );
};

export default CompanyLogos;
